import { GlButton, GlTooltip } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { mapState, mapActions } from '../../../../../../node_modules/pinia/dist/pinia.mjs?vue3';
import { __ } from '~/locale';
import { useFileTreeBrowserVisibility } from '../../stores/file_tree_browser_visibility.js?vue3';
import Shortcut from '../../../behaviors/shortcuts/shortcut.vue?vue3';
import { keyboardShortcutsDisabled } from '~/behaviors/shortcuts/shortcuts_disabled';
import { TOGGLE_FILE_TREE_BROWSER_VISIBILITY } from '~/behaviors/shortcuts/keybindings';
import { InternalEvents } from '../../../tracking/index.js?vue3';
import { EVENT_COLLAPSE_FILE_TREE_BROWSER_ON_REPOSITORY_PAGE, EVENT_EXPAND_FILE_TREE_BROWSER_ON_REPOSITORY_PAGE } from '~/repository/constants';
export default {
    name: 'FileTreeBrowserDrawerToggle',
    TOGGLE_FILE_TREE_BROWSER_VISIBILITY,
    components: {
        Shortcut,
        GlButton,
        GlTooltip
    },
    mixins: [
        InternalEvents.mixin()
    ],
    props: {
        isAnimating: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            suppressTooltip: false
        };
    },
    computed: {
        ...mapState(useFileTreeBrowserVisibility, [
            'fileTreeBrowserIsVisible',
            'shouldRestoreFocusToToggle'
        ]),
        toggleFileBrowserTitle () {
            return this.fileTreeBrowserIsVisible ? __('Hide file tree browser') : __('Show file tree browser');
        },
        shortcutsEnabled () {
            return !keyboardShortcutsDisabled();
        },
        target () {
            return ()=>this.$refs.toggle?.$el;
        }
    },
    watch: {
        shouldRestoreFocusToToggle (newValue) {
            if (newValue) this.$nextTick(()=>this.restoreToggleFocus());
        }
    },
    mounted () {
        if (this.shouldRestoreFocusToToggle) this.$nextTick(()=>this.restoreToggleFocus());
    },
    methods: {
        ...mapActions(useFileTreeBrowserVisibility, [
            'handleFileTreeBrowserToggleClick',
            'clearRestoreFocusFlag'
        ]),
        restoreToggleFocus () {
            this.$refs.toggle?.$el?.focus();
            this.clearRestoreFocusFlag();
            this.suppressTooltip = true;
            setTimeout(()=>{
                this.suppressTooltip = false;
            }, 0);
        },
        onClickToggle () {
            this.handleFileTreeBrowserToggleClick();
            this.trackEvent(this.fileTreeBrowserIsVisible ? EVENT_EXPAND_FILE_TREE_BROWSER_ON_REPOSITORY_PAGE : EVENT_COLLAPSE_FILE_TREE_BROWSER_ON_REPOSITORY_PAGE, {
                label: 'click'
            });
        }
    }
};
